import Discussion from "src/components/NewComponents/Exam/OptionDetails/Discussion/Discussion";
import Articles from "./Articles";
import Comments from "./Comments";
import { Notes } from "./Notes";
import ReportErrorInQuestion from "./ReportErrorInQuestion";

function DefaultOptionDetails({
	settings,
	question,
	dispatch,
	actions,
	className,
	details,
	folders,
}) {
	const onClose = (key) => {
		if (dispatch) {
			return dispatch(actions.toggleSettings(key));
		}

		return actions.toggleSettings(key);
	};

	return (
		<div className={className}>
			<Discussion
				settings={settings}
				question={question}
				onClose={onClose}
				dispatch={dispatch}
				actions={actions}
				details={details}
			/>
			<Comments
				settings={settings}
				question={question}
				onClose={onClose}
				dispatch={dispatch}
				actions={actions}
			/>
			<Articles
				settings={settings}
				question={question}
				onClose={onClose}
				dispatch={dispatch}
				actions={actions}
			/>
			<Notes
				settings={settings}
				question={question}
				folders={folders}
				onClose={onClose}
				dispatch={dispatch}
				actions={actions}
			/>
			<ReportErrorInQuestion
				settings={settings}
				question={question}
				onClose={onClose}
				dispatch={dispatch}
				actions={actions}
			/>
		</div>
	);
}

export default DefaultOptionDetails;
